export default __webpack_public_path__ + "static/media/274.4e03558b.gif";